export default {
  meta: {
    name: '创建',
    title: '需求操作-',
    dynamicWithName: true, // 是否需要动态合并name参数
    crumbs: { // 面包屑群组，必须同时带上 path 和 name 参数
      path: ['/'],
      name: ['选址需求']
    }
  }
};
